import { Grid,Card,CardContent, makeStyles ,Button ,Typography} from '@material-ui/core';
import React from 'react'

import { Call } from '@material-ui/icons';


const useStyles = makeStyles((theme) => ({
    video: {
      width: '550px',
      [theme.breakpoints.down('xs')]: {
        width: '300px',
      },
    },
    Container: {

      justifyContent: 'center',
      width:"100%",
      height:'100vh',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    paper: {
      padding: '10px',
      border: '2px solid black',
      margin: '10px',
      
    },
    Text_Container:{
      // /textAlign:"center",
      alignItems:"center",
  
      paddingTop:'10%',
    },

    Main_Text:{
      color:"white",
        fontSize:"20vh",
        [theme.breakpoints.down('xs')]: {
          fontSize:"12vh"
        },
        margin:'0',
        paddingBottom:"2%",
        paddingLeft:"2%",
    },
    Sub_Text:{
      color:"white",
      fontSize:"9vh",
      [theme.breakpoints.down('xs')]: {
          fontSize:"5vh",
      },
      margin:'0',
      paddingBottom:"3%",
      paddingLeft:"2%",
    },
    Butt:{
      margin:"2%",
      borderRadius:"4%",
      color:"rgb(65,158,207)"
    }


  })); 


const Firstpage = () => {
    const css = useStyles();
  return (
    <>
        <div  className={css.Container}>

            <div className={css.Text_Container}>
                  <h2 className={css.Main_Text}>
                    Hey
                  </h2>
                  <p className={css.Sub_Text}>
                  Welcome to Peer-to-Peer
                  </p>
            </div>
            <Grid item xs={12} md={6} style={{paddingLeft:"2%"}}>          
            <Card sx={{ minWidth: 275 }}   style={{paddingTop:"3%" ,}}>
              <CardContent>
                <Typography variant="h5" sx={{ fontSize: 14 }} gutterBottom style={{color:"rgb(65,158,207)" }}>
                      This is a new Web-App "Peer-to-Peer" where you can  Video 
                      Call  with you Friends Without any login or signup 
                      just share the link and start   your video call.
                </Typography>
              </CardContent>
            </Card>
            </Grid>      
        </div>



    </>
  )
}

export default Firstpage